import React, { useEffect, useState } from 'react';
import CanvasJSReact from '../../../assets/canvasjs.react';
import { convertTimezone } from '../../../utils';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const GasRow = ({data}) =>  {
  const [loading, setLoading] = useState(true);
  const [totalGas, setTotalGas] = useState();
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if(!data) {
      return
    }
    let total = 0;
    const new_data = []
    data.data.map(it => {
      total = it.v ? total + it.v : total + 0
      new_data.push({
        x: new Date(it.at + convertTimezone(it.at)),
        y: it.v
      })
    })
    setTotalGas(total.toFixed(2));
    setChartData(new_data);
    setLoading(false);
  },[data])


  return (
    <div className="grid grid-cols-12 border-t py-3">
      <div className="col-start-1 col-end-8">Потребление газа</div>
      <div className="col-start-9 col-end-11 font-normal flex justify-end">литры</div>
      <div className="col-start-12 col-end-12 flex justify-end">{totalGas}</div>
    </div>
  );
}

export default GasRow;
